export { createPageContext };
import { getPageContextUrlComputed } from '../../shared/getPageContextUrlComputed.js';
import { getPageFilesAll } from '../../shared/getPageFiles.js';
import { loadPageRoutes } from '../../shared/route/loadPageRoutes.js';
import { getBaseServer } from './getBaseServer.js';
import { assert, isBaseServer, getGlobalObject, objectAssign } from './utils.js';
const globalObject = getGlobalObject('createPageContext.ts', {});
async function createPageContext(urlOriginal) {
    if (!globalObject.pageFilesData) {
        globalObject.pageFilesData = await getPageFilesAll(true);
    }
    const { pageFilesAll, allPageIds, pageConfigs, pageConfigGlobal } = globalObject.pageFilesData;
    const { pageRoutes, onBeforeRouteHook } = await loadPageRoutes(pageFilesAll, pageConfigs, pageConfigGlobal, allPageIds);
    const baseServer = getBaseServer();
    assert(isBaseServer(baseServer));
    const pageContext = {
        urlOriginal,
        _objectCreatedByVike: true,
        _urlHandler: null,
        _urlRewrite: null,
        _baseServer: baseServer,
        _pageFilesAll: pageFilesAll,
        _pageConfigs: pageConfigs,
        _pageConfigGlobal: pageConfigGlobal,
        _allPageIds: allPageIds,
        _pageRoutes: pageRoutes,
        _onBeforeRouteHook: onBeforeRouteHook
    };
    const pageContextUrlComputed = getPageContextUrlComputed(pageContext);
    objectAssign(pageContext, pageContextUrlComputed);
    return pageContext;
}
